import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { weekCalculationUtil } from '~/modules/common/dates/weekUtil';
import {
  getUserPreferenceWeekStart,
  getUserPreferenceWeekEnd
} from '~/modules/common/dates/dayOfWeek';

export const createCustomAdapterLuxon = me => {
  const workWeekStartUri = me?.workWeekStartDay?.uri;

  return class CustomAdapterLuxon extends AdapterLuxon {
    constructor(options) {
      super(options);

      // Normal inheritance doesn't work because MUI X defines methods as arrow function
      // properties (not prototype methods), so they must be replaced on the instance.
      this.getWeekdays = () =>
        weekCalculationUtil.getWeekdays(workWeekStartUri);

      this.getWeekArray = date =>
        weekCalculationUtil.getWeekArray(date, workWeekStartUri);

      this.startOfWeek = date => getUserPreferenceWeekStart(me, date);

      this.endOfWeek = date => getUserPreferenceWeekEnd(me, date);
    }
  };
};

export default createCustomAdapterLuxon;
